import React, { useState } from "react";
// reactstrap components
import {
    Container,
} from "reactstrap";
import { Route, Redirect } from 'react-router-dom';

import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader2.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};

//function TelePage2() {
const NurseCall = (props) => {

    var moment = require('moment');
    require('moment/locale/th');

    const liff = window.liff;
    liff.init({
        liffId: '1654063801-PwXBy90W'
    })
        .then(() => {

            if (liff.isLoggedIn()) {
                /*
                liff.getProfile().then(function (profile) {
                    setLineTrangskin(profile.userId);
                }).catch(function (error) {
                    window.alert('Error getting profile: ' + error);
                });
                */
            }
        })
        .catch((err) => {

        });

    React.useEffect(() => {
        

        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };
    }, []);

    const [ServiceType, setType] = useState("");
    const [AppointDatetime, setDate] = useState("");
    
    const handleSubmit = (evt) => {
        evt.preventDefault();

        
    }

    const handleConfirm = (evt) => {
        evt.preventDefault();
       
    }

    //authenticationService.logout();
    const currentUser = authenticationService.currentUserValue;
    //console.log(currentUser);

    //check login
    if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    }

    const onSubmit = values => {
      
    };

    return (
        <>
            <IndexNavbar />
            <div className="wrapper">
                <IndexHeader />

                <div className="main">
                    
                </div>

                <div className="section section-contact-us" style={{ padding: 0 }}>
                    
                </div>
                <DefaultFooter />
            </div>
        </>
    );
}

export default NurseCall;
